const prefix = process.env.VUE_APP_API_PREFIX

export default [
  {
    name: 'tableQuery',
    path: `${prefix}/order/userList`,
    method: 'get',
    params: {
      page: 1,
      limit: 10,
      orderId: '',
      productTypes: '',
      status: '',
      types: '',
      payTypes: '',
      startTime: '',
      endTime: '',
      priceSort: ''
    },
    desc: '订单相关-用户订单列表-控制台使用'
  },
  {
    name: 'orderCancel',
    path: `${prefix}/order/cancel`,
    method: 'post',
    params: {
      orderId: ''
    },
    desc: '订单相关-取消订单'
  },
  {
    name: 'orderDetail',
    path: `${prefix}/order/detail`,
    method: 'get',
    params: {
      orderId: ''
    },
    desc: '订单相关-订单详情'
  },
  {
    name: 'orderDailyDetail',
    path: `${prefix}/order/dailyDetail`,
    method: 'get',
    params: {
      orderId: ''
    },
    desc: '订单相关-每日订单详情'
  },
  {
    name: 'packageUnsubDetail',
    path: `${prefix}/package/unsubDetail`,
    method: 'get',
    params: {
      packageId: ''
    },
    desc: '套餐相关-套餐退订详情'
  },
  {
    name: 'packageUnsub',
    path: `${prefix}/package/unsub`,
    method: 'post',
    params: {
      packageId: '',
      validateCode: ''
    },
    desc: '套餐相关-套餐退订'
  },
  {
    name: 'orderUnsubDetail',
    path: `${prefix}/order/unsubDetail`,
    method: 'get',
    params: {
      orderId: '',
      unsubStatus: ''
    },
    desc: '订单相关-退订订单详情'
  },
  {
    name: 'unsubCode',
    path: `${prefix}/package/sendUnsubCode`,
    method: 'post',
    params: {},
    desc: '退订验证码'
  }
]
